/* Barrel Station collection page: filters, sort and "Show more" update in place; filter sheet on tablets and phones.
   Sold-out bottles last: when the grid has data-bs-soldlast and the shopper starts on page 1, the next pages are
   fetched in the background and every in-stock bottle in the collection is shown before any sold-out one. */
(function () {
  if (window.BSCollection) return;
  window.BSCollection = true;

  var mobileQuery = window.matchMedia('(max-width: 989px)');

  function withSection(url, id) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', id);
    return u.toString();
  }

  function cleanUrl(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    return u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');
  }

  function init(root) {
    if (root.dataset.bsReady) return;
    root.dataset.bsReady = '1';
    var sectionId = root.dataset.section;
    var opener = null;
    var priceTimer = null;
    var busy = false;
    var queue = null;
    var generation = 0;

    function q(sel) { return root.querySelector(sel); }
    function sheet() { return q('[data-bs-sheet]'); }
    function dim() { return q('.bs-sheet__dim'); }

    function openSheet(noAnim) {
      var s = sheet();
      if (!s) return;
      if (noAnim) s.style.transition = 'none';
      s.classList.add('is-open');
      if (dim()) dim().hidden = false;
      document.body.classList.add('bs-sheet-open');
      var btn = q('[data-bs-sheet-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (noAnim) { void s.offsetWidth; s.style.transition = ''; }
      else s.focus({ preventScroll: true });
    }

    function closeSheet() {
      var s = sheet();
      if (!s || !s.classList.contains('is-open')) return;
      s.classList.remove('is-open');
      if (dim()) dim().hidden = true;
      document.body.classList.remove('bs-sheet-open');
      var btn = q('[data-bs-sheet-open]');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus({ preventScroll: true }); }
    }

    function buildUrl() {
      var form = q('[data-bs-facets]');
      var params = new URLSearchParams();
      var fd = new FormData(form);
      fd.forEach(function (value, key) {
        if (key === 'sort_by' || value === '') return;
        params.append(key, value);
      });
      var sorts = root.querySelectorAll('[data-bs-sort]');
      var want = mobileQuery.matches ? 'mobile' : 'desktop';
      var chosen = null;
      sorts.forEach(function (sel) { if (sel.dataset.bsOnly === want) chosen = sel; });
      if (!chosen && sorts.length) chosen = sorts[0];
      if (chosen) params.set('sort_by', chosen.value);
      var base = form.getAttribute('action') || window.location.pathname;
      var qs = params.toString();
      return base + (qs ? '?' + qs : '');
    }

    function render(url, push) {
      if (busy) return;
      busy = true;
      var main = q('.bs-plp__main');
      if (main) main.classList.add('is-loading');
      var wasOpen = sheet() && sheet().classList.contains('is-open');
      var body = q('.bs-sheet__body');
      var scrollTop = body ? body.scrollTop : 0;
      var active = document.activeElement && root.contains(document.activeElement) ? document.activeElement.id : null;
      fetch(withSection(url, sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-bs-plp]');
          if (!fresh) { window.location.href = url; return; }
          root.innerHTML = fresh.innerHTML;
          setupQueue();
          if (wasOpen) {
            openSheet(true);
            var nb = q('.bs-sheet__body');
            if (nb) nb.scrollTop = scrollTop;
          }
          if (active) {
            var el = document.getElementById(active);
            if (el) el.focus({ preventScroll: true });
          }
          if (push) window.history.pushState({ bsPlp: true }, '', cleanUrl(url));
        })
        .catch(function () { window.location.href = url; })
        .then(function () {
          busy = false;
          var m = q('.bs-plp__main');
          if (m) m.classList.remove('is-loading');
        });
    }

    /* ---- Sold-out bottles last, across the whole collection ---- */
    function cardKey(card) {
      var a = card.querySelector('a.bs-pcard__name') || card.querySelector('a');
      if (!a) return '';
      try { return new URL(a.getAttribute('href'), window.location.origin).pathname; } catch (err) { return a.getAttribute('href'); }
    }
    function isSold(card) { return card.classList.contains('is-soldout'); }
    function gridCards(grid) { return Array.prototype.slice.call(grid.querySelectorAll(':scope > .bs-pcard')); }

    function pagerTotal() {
      var count = q('[data-bs-pager] .bs-count');
      var strongs = count ? count.querySelectorAll('strong') : [];
      var n = strongs.length > 1 ? parseInt(strongs[strongs.length - 1].textContent, 10) : NaN;
      return isNaN(n) ? 0 : n;
    }

    function setupQueue() {
      queue = null;
      generation += 1;
      var grid = q('[data-bs-grid]');
      var more = q('[data-bs-more]');
      if (!grid || !grid.hasAttribute('data-bs-soldlast') || !more) return;
      var nextUrl = new URL(more.href, window.location.origin);
      if (parseInt(nextUrl.searchParams.get('page') || '0', 10) !== 2) return;
      var last = 2;
      root.querySelectorAll('[data-bs-pages] a, [data-bs-pages] span').forEach(function (el) {
        var n = parseInt(el.textContent, 10);
        if (!isNaN(n) && n > last) last = n;
      });
      if (last > 40) return;
      var cards = gridCards(grid);
      if (!cards.length) return;
      var Q = {
        gen: generation, grid: grid, more: more, base: nextUrl,
        batch: cards.length, next: 2, last: last, done: false, failed: false,
        inStock: [], soldOut: [], seen: {}, pending: null, shown: cards.length
      };
      cards.forEach(function (c) {
        Q.seen[cardKey(c)] = true;
        (isSold(c) ? Q.soldOut : Q.inStock).push(c);
      });
      queue = Q;
      var pages = q('[data-bs-pages]');
      if (pages) pages.hidden = true;
      fill(Q, Q.batch, false).then(function () { if (queue === Q) ensure(Q, Q.shown + Q.batch); });
    }

    function fetchPage(Q) {
      var u = new URL(Q.base.toString());
      u.searchParams.set('page', String(Q.next));
      return fetch(withSection(u.toString(), sectionId))
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          if (Q.gen !== generation) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[data-bs-grid]');
          if (!g) throw new Error('no grid');
          gridCards(g).forEach(function (c) {
            var k = cardKey(c);
            if (Q.seen[k]) return;
            Q.seen[k] = true;
            var card = document.importNode(c, true);
            (isSold(card) ? Q.soldOut : Q.inStock).push(card);
          });
          Q.next += 1;
          if (!doc.querySelector('[data-bs-more]') || Q.next > 60) Q.done = true;
        });
    }

    /* Fetches pages, one at a time, until there are `target` in-stock bottles to show or the collection runs out. */
    function ensure(Q, target) {
      if (Q.pending) return Q.pending.then(function () { return ensure(Q, target); });
      if (Q.done || Q.failed || Q.gen !== generation || Q.inStock.length >= target) return Promise.resolve();
      Q.pending = fetchPage(Q)
        .catch(function () { Q.failed = true; })
        .then(function () { Q.pending = null; });
      return Q.pending.then(function () { return ensure(Q, target); });
    }

    function fill(Q, target, focusNew) {
      return ensure(Q, target).then(function () {
        if (Q.gen !== generation) return;
        var list = Q.inStock.slice(0, target);
        if (list.length < target && Q.done) list = list.concat(Q.soldOut.slice(0, target - list.length));
        if (Q.failed && list.length < Q.shown) return;
        var current = gridCards(Q.grid);
        var i = 0;
        while (i < current.length && i < list.length && current[i] === list[i]) i += 1;
        for (var j = i; j < current.length; j += 1) current[j].remove();
        for (var k = i; k < list.length; k += 1) Q.grid.appendChild(list[k]);
        var before = Q.shown;
        Q.shown = list.length;
        var total = pagerTotal() || (Q.inStock.length + Q.soldOut.length);
        var shownEl = q('[data-bs-shown]');
        if (shownEl) shownEl.textContent = Q.shown;
        var bar = q('[data-bs-bar]');
        if (bar && total) bar.style.width = Math.min(100, Math.round(Q.shown * 1000 / total) / 10) + '%';
        if (Q.done && Q.shown >= Q.inStock.length + Q.soldOut.length) {
          if (Q.more && Q.more.parentNode) Q.more.remove();
        }
        if (focusNew && list[before]) {
          var a = list[before].querySelector('a.bs-pcard__name');
          if (a) a.focus({ preventScroll: true });
        }
      });
    }

    function showMoreQueued(link) {
      var Q = queue;
      if (link.classList.contains('is-loading')) return;
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');
      var before = Q.shown;
      fill(Q, Q.shown + Q.batch, true).then(function () {
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
        if (Q.gen !== generation) return;
        if (Q.failed && Q.shown === before) { window.location.href = link.href; return; }
        ensure(Q, Q.shown + Q.batch);
      });
    }

    function loadMore(link) {
      if (link.classList.contains('is-loading')) return;
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');
      fetch(withSection(link.href, sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = q('[data-bs-grid]');
          var newGrid = doc.querySelector('[data-bs-grid]');
          if (!grid || !newGrid) { window.location.href = link.href; return; }
          var first = newGrid.querySelector('.bs-pcard:not(.is-soldout)') || newGrid.firstElementChild;
          while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
          if (grid.hasAttribute('data-bs-soldlast')) {
            grid.querySelectorAll('.bs-pcard.is-soldout').forEach(function (card) { grid.appendChild(card); });
          }
          var shown = doc.querySelector('[data-bs-shown]');
          var bar = doc.querySelector('[data-bs-bar]');
          if (shown && q('[data-bs-shown]')) q('[data-bs-shown]').textContent = shown.textContent;
          if (bar && q('[data-bs-bar]')) q('[data-bs-bar]').style.width = bar.style.width;
          var next = doc.querySelector('[data-bs-more]');
          if (next) link.href = next.href; else link.remove();
          var pages = q('[data-bs-pages]');
          if (pages) pages.hidden = true;
          if (first) {
            var a = first.querySelector('a.bs-pcard__name');
            if (a) a.focus({ preventScroll: true });
          }
        })
        .catch(function () { window.location.href = link.href; })
        .then(function () { link.classList.remove('is-loading'); link.removeAttribute('aria-busy'); });
    }

    root.addEventListener('click', function (e) {
      var acc = e.target.closest('[data-bs-acc]');
      if (acc) {
        var open = acc.getAttribute('aria-expanded') === 'true';
        acc.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = document.getElementById(acc.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
        return;
      }
      var op = e.target.closest('[data-bs-sheet-open]');
      if (op) { opener = op; openSheet(false); return; }
      if (e.target.closest('[data-bs-sheet-close]')) { closeSheet(); return; }
      var more = e.target.closest('[data-bs-more]');
      if (more) { e.preventDefault(); if (queue && queue.more === more) showMoreQueued(more); else loadMore(more); return; }
      var link = e.target.closest('a[data-bs-link], [data-bs-pages] a');
      if (link) { e.preventDefault(); render(link.href, true); }
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-bs-sort]')) {
        root.querySelectorAll('[data-bs-sort]').forEach(function (s) { s.value = t.value; });
        render(buildUrl(), true);
      } else if (t.matches('[data-bs-price]')) {
        clearTimeout(priceTimer);
        render(buildUrl(), true);
      } else if (t.matches('input[type="checkbox"]') && t.form && t.form.hasAttribute('data-bs-facets')) {
        render(buildUrl(), true);
      }
    });

    root.addEventListener('input', function (e) {
      if (!e.target.matches('[data-bs-price]')) return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () { render(buildUrl(), true); }, 900);
    });

    root.addEventListener('submit', function (e) {
      if (e.target.matches('[data-bs-facets]')) { e.preventDefault(); render(buildUrl(), true); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
      /* Phone filter panel: keep Tab inside it while it's open (it covers the page) */
      if (e.key === 'Tab') {
        var s = sheet();
        if (s && s.classList.contains('is-open')) {
          var f = Array.prototype.filter.call(s.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
          if (f.length) {
            var first = f[0];
            var last = f[f.length - 1];
            if (e.shiftKey && (document.activeElement === first || document.activeElement === s)) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
          }
        }
      }
      if (e.key === 'Enter' && e.target.matches('[data-bs-price]')) { e.preventDefault(); clearTimeout(priceTimer); render(buildUrl(), true); }
    });

    window.addEventListener('popstate', function () { render(window.location.href, false); });
    mobileQuery.addEventListener && mobileQuery.addEventListener('change', function (ev) { if (!ev.matches) closeSheet(); });
    setupQueue();
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-bs-plp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
